<div class="login_container">
  <div class="card">

      <div class="logo">
        <img src="{{logoUrl}}"/>
      </div>

      <p>Digite seu e-mail para recuperar sua senha.</p>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

          <div class="form-group">
            <input type="text" class="form-control" id="user" placeholder="Digite aqui" formControlName="user">
          </div>
          
          <app-button _label="Enviar" _class="btn-primary"></app-button>
          <app-button _label="Voltar" _class="return-login" (click)="voltar()"></app-button>

          <div *ngIf="submitted && formHasErrors()" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle"></i>
            <span *ngIf="userHasErrors()" >O campo e-mail é obrigatório.</span>
          </div>

          <div *ngIf="invalidLogin" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle"></i>
              <span>E-mail não cadastrado.</span>
          </div>

      </form>
      

  </div>
</div>
